import React from "react";
import {
  Box,
  Paper,
  Select,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  TextField,
  CircularProgress,
} from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  ReferenceLine,
  Area,
  AreaChart,
  Dot,
} from "recharts";
import OpenWithIcon from '@mui/icons-material/OpenWith';

function SugarIntakeChart({ sugarChartData, page, title, idealValue ,handleOpen,settingType }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // flex: 1,
        width: page === "Lifestyle" ? { xl:"85%", xl:'85%', md:'60%'} : "100%",
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'space-between' }}>
        <Typography
          variant="p"
          align="left"
          sx={{ marginLeft: 2, fontSize: "15px", fontWeight: "bold", }}
        >
         {title
          ?.toLowerCase()
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}
        </Typography>

        {handleOpen && <OpenWithIcon onClick={() => {
          handleOpen()
          settingType(title)
        }} sx={{ alignSelf: 'flex-end', right: 20, cursor:'pointer',fontSize:'medium' }} />}
      </Box>

      <Typography variant="p" align="right" fontSize={page === "Lifestyle" ? "9px" :handleOpen? "9px": '13px'}>
        Ideal - {idealValue}
      </Typography>
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
      <BarChart
        width={page === "Lifestyle" ? 290 : handleOpen? 400 : 600}
        height={handleOpen ? 130 :page === "Lifestyle" ?130: 300}
        data={sugarChartData}
        style={{ fontSize: "8px" }}
        margin={{ top: 10, right: 30, left: -30, bottom: 0 }}
      >
        <XAxis dataKey="week" axisLine={false} tickLine={false} tick={{fill: "#000", fontSize: '8px', fontWeight:'bold' }} />
        <YAxis axisLine={false}  domain={[0, 'maxValue']}  tickLine={false} tick={{fill: "#000", fontSize: '8px', fontWeight:'bold' }}/>
        <Tooltip />
        <Bar
          dataKey={"maxValue"}
          name={"Recommended"}
          fill="#b0b8c1"
          radius={[10, 10, 0, 0]}
          isAnimationActive={false}
        />
        <Bar
          dataKey="answer"
          name={"Sugar"}
          fill="#9ee5f7"
          radius={[10, 10, 0, 0]}
          isAnimationActive={false}
        />
      </BarChart>
      </Box>
    </Box>
  );
}

export default SugarIntakeChart;
